import T from 'prop-types';
import React from 'react';

import { ReactComponent as LogoInverted } from '@skippay/core/assets/logos/skippay-inverted.svg';
import { ReactComponent as LogoDarkmode } from '@skippay/core/assets/logos/skippay-white.svg';
import { ReactComponent as LogoDefault } from '@skippay/core/assets/logos/skippay.svg';
import { FormattedMessage } from '@skippay/core/i18n/intl';
import { bm } from '@skippay/core/utils/classUtils';

import './index.sass';

const MODULE_NAME = 'Logo';

const Logo = (props) => {
	const { lg, md, sm, wide } = props;

	return (
		<div className={bm(MODULE_NAME, { lg, md, sm, wide })}>
			<span className="visually-hidden">
				<FormattedMessage defaultMessage="Skippay" id="Logo" />
			</span>
			{props.inverted ? (
				<LogoInverted className="d-dark-none" />
			) : (
				<LogoDefault className="d-dark-none" />
			)}
			<LogoDarkmode className="d-dark-block" />
		</div>
	);
};

Logo.propTypes = {
	inverted: T.bool,
	sm: T.bool,
	md: T.bool,
	lg: T.bool,
	wide: T.bool,
};

export default Logo;
